import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'lodash-es';

import { hideModal } from 'redux/actions/global';
import { resetReduxResetPinState } from 'redux/actions/issuing/reset';
import { getResetPINData } from 'redux/selectors/issuing';
import { ModalWrapper } from 'components/containers/Modal/shared/SharedModalStyles';
import ResetPINWidget from 'components/widgets/ResetPINWidget/ResetPINWidget';

interface IProps {
  token: string;
  codeLength: number;
}

const ResetPINModal = ({ token, codeLength }: IProps) => {
  const dispatch = useDispatch();
  const resetPINData = useSelector(getResetPINData);
  const resetSuccess = !isEmpty(resetPINData);

  const closeModal = () => dispatch(hideModal());

  useEffect(() => {
    // returned function will be called on component unmount
    return () => {
      dispatch(resetReduxResetPinState());
    };
  }, []);

  useEffect(() => {
    if (!resetSuccess) {
      return;
    }
    closeModal();
  }, [resetSuccess]);

  return (
    <ModalWrapper>
      <ResetPINWidget
        token={token}
        codeLength={codeLength}
        unAuthorizeCallback={closeModal}
        dispatchToastSuccessMsg
        isModal
      />
    </ModalWrapper>
  );
};

export default ResetPINModal;
